import React, { Component } from 'react'

import classNames from './ChannelInfo.css'
import LoadingSpinner from '../LoadingSpinner'

export default class ChannelInfo extends Component {
  filterAlbums (fn) {
    const albums = []
    for (let playlist of this.props.data.playlists) {
      for (let album of playlist.albums) {
        if (fn(album)) {
          albums.push(album)
        }
      }
    }
    return albums
  }
  renderPlayNow () {
    // let albums = this.filterAlbums(album => album._origin === 'play_now')
    // if (albums.length === 0) {
    //   albums = this.filterAlbums(album => album._state === 'playing')
    // }
    const albums = this.filterAlbums(album => album._state === 'playing')
    return (
      <div>
        <div className={classNames.mainHeading}>
          Now playing
        </div>
        {albums.length === 0
          ? 'None'
          : albums.map(this.renderAlbum)
        }
      </div>
    )
  }
  renderPlayNext () {
    const albums = this.filterAlbums(album => album._temporary && album._state !== 'playing')
    if (albums.length === 0) {
      return null
    }
    return (
      <div>
        {albums.map(this.renderAlbum)}
      </div>
    )
  }
  renderPlaylist = (playlist, playlistIndex) => {
    const albums = playlist.albums.filter(album => {
      return !album._temporary && (album._state === 'present' || album._state === 'skipped')
    })
    if (albums.length === 0) {
      return null
    }
    return (
      <div>
        <div className={classNames.heading}>{playlist.name}</div>
        {albums.map((album, index) => this.renderAlbum(album, index, playlistIndex))}
      </div>
    )
  }
  renderAlbum = (album, albumIndex, playlistIndex) => {
    const { getImageSource, onSkip, onUnskip } = this.props
    const skipped = album._state === 'skipped'
    const conflicts = this.props.conflicts
      .filter(c => c.playlist === playlistIndex && c.album === albumIndex)
      .map(c => c.conflict)
    const external = album._temporary
    return (
      <div key={album._id} className={classNames.album}>
        <div className={classNames.albumThumb} style={{ backgroundImage: `url(${getImageSource(album.cover)})` }} />
        <div className={classNames.albumInfo}>
          {album.name}
          <div className={classNames.albumCount}>
            {album._total_images} photos
            {external &&
              ', added via Play Next'
            }
          </div>
          <ul>
            {conflicts.map(this.renderConflict)}
          </ul>
        </div>
        <div className={classNames.tools}>
          {this.props.isOwner &&
            <button onClick={skipped ? onUnskip : onSkip} value={album._id}>
              {skipped ? 'Unskip' : (external ? 'Remove' : 'Skip')}
            </button>
          }
        </div>
      </div>
    )
  }
  renderReason = reason => {
    return (
      <li key={reason} className={classNames.reason}>
        {reason}
      </li>
    )
  }
  renderConflict = conflict => {
    return (
      <li key={conflict} className={classNames.conflict}>
        {conflict}
      </li>
    )
  }
  render () {
    if (!this.props.data) {
      return <LoadingSpinner />
    }
    const { data, padded } = this.props
    const upNext = this.renderPlayNext()
    return (
      <div className={padded ? classNames.paddedWrapper : classNames.wrapper}>
        {this.renderPlayNow()}
        {upNext &&
          <div className={classNames.mainHeading}>
            Up next
          </div>
        }
        {upNext}
        {data.playlists.map(this.renderPlaylist)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/present/ChannelInfo.js